import { render, staticRenderFns } from "./MemoriaCartas.vue?vue&type=template&id=1cb3a5f0&"
import script from "./MemoriaCartas.vue?vue&type=script&lang=js&"
export * from "./MemoriaCartas.vue?vue&type=script&lang=js&"
import style0 from "./MemoriaCartas.vue?vue&type=style&index=0&id=1cb3a5f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports